import { Country } from '@/types/country/country';

export const countryTypes = {
  startLoadingCountries: '[COUNTRIES] Start Loading',
  finishLoadingCountries: '[COUNTRIES] Finish Loading',
  countriesLoad: '[COUNTRIES] Load Countries',
};

interface StartLoadingCountriesAction {
  type: typeof countryTypes.startLoadingCountries;
  payload: null;
}

interface FinishLoadingCountriesAction {
  type: typeof countryTypes.finishLoadingCountries;
  payload: null;
}

interface CountriesLoadAction {
  type: typeof countryTypes.countriesLoad;
  payload: Country[];
}

export type CountryActions = StartLoadingCountriesAction | FinishLoadingCountriesAction | CountriesLoadAction;
